import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { PlanTypeCategory } from '../../enum';
import { ROUTER_URL } from '../../router';
import { ConfirmDialog } from '../common';
import { useCancelSimulation, useDeleteScenario, useReportAPI } from '../report/selectors';
import { useSummaryReportAPI } from './selectors';
export var DeleteScenarioDialog = function (_a) {
  var open = _a.open,
    scenario = _a.scenario,
    onClose = _a.onClose;
  var t = useTranslation(['report', 'translation']).t;
  var _b = useDeleteScenario(scenario === null || scenario === void 0 ? void 0 : scenario.id),
    deleteScenarioData = _b[0],
    deleteScenario = _b[1],
    clearDeleteScenario = _b[2];
  var _c = useCancelSimulation(scenario === null || scenario === void 0 ? void 0 : scenario.id, scenario === null || scenario === void 0 ? void 0 : scenario.basePlanId),
    cancelSimulation = _c[1];
  var _d = useReportAPI(),
    fetchData = _d[1];
  var _e = useSummaryReportAPI(),
    fetchSummaryData = _e[1];
  var basePlanId = useParams().basePlanId;
  var navigate = useNavigate();
  useEffect(function () {
    if (open && deleteScenarioData.data) {
      onClose();
      var newBasePlanId = deleteScenarioData.data.basePlanId;
      if (newBasePlanId && basePlanId && String(newBasePlanId) !== basePlanId) {
        navigate(generatePath(ROUTER_URL.Report, {
          basePlanId: String(newBasePlanId)
        }), {
          replace: true
        });
        return;
      }
      fetchData();
      fetchSummaryData(true);
    }
    return clearDeleteScenario;
  }, [deleteScenarioData.data, fetchSummaryData, onClose, fetchData, open, clearDeleteScenario, basePlanId, navigate]);
  var handleDeleteScenario = function () {
    deleteScenario();
    cancelSimulation({
      isCancelAll: false
    });
  };
  var isProdHours = (scenario === null || scenario === void 0 ? void 0 : scenario.planTypeCategory) === PlanTypeCategory.ProdHours;
  var messageKey = isProdHours ? 'translation:confirmation.yesDeleteProdHours' : 'translation:confirmation.yesDeleteMultiskill';
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('translation:confirmation.title'),
    message: t(messageKey),
    onConfirm: handleDeleteScenario,
    confirmButtonText: 'continue',
    loading: deleteScenarioData.requesting,
    errors: [deleteScenarioData.error]
  });
};